export interface BNBTokenPayload {
  address: string;
  blockchain: 'bnb';
  timestamp: number;
  expiresAt: number;
}

export async function createBNBToken(
  signer: any, // JsonRpcSigner from ethers
  expireTime = '30d',
): Promise<string> {
  try {
    if (!signer || !signer.getAddress) {
      throw new Error('Invalid BNB signer');
    }

    const address = await signer.getAddress();
    const timestamp = Math.floor(Date.now() / 1000);

    // Calculate expiration time
    const expireSeconds = parseExpireTime(expireTime);
    const expiresAt = timestamp + expireSeconds;

    // Create payload
    const payload: BNBTokenPayload = {
      address,
      blockchain: 'bnb',
      timestamp,
      expiresAt,
    };

    // Create message to sign
    const message = `Sign this message to authenticate with LixiNFT: ${JSON.stringify(
      payload,
    )}`;

    // Sign with BNB signer
    const signature = await signer.signMessage(message);

    // Create token with blockchain header (same format as Solana)
    const token = `bnb.${btoa(JSON.stringify(payload))}.${signature}`;

    console.log('BNB token created:', {
      address: address.substring(0, 8) + '...',
      blockchain: 'bnb',
      tokenLength: token.length,
    });

    return token;
  } catch (error) {
    console.error('Create BNB token error:', error);
    throw new Error(
      `Failed to create BNB token: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
}

function parseExpireTime(expireTime: string): number {
  const timeUnits: { [key: string]: number } = {
    s: 1,
    m: 60,
    h: 3600,
    d: 86400,
    w: 604800,
    M: 2592000, // 30 days
    y: 31536000,
  };

  const match = expireTime.match(/^(\d+)([smhdwMy])$/);
  if (!match) {
    throw new Error(`Invalid expire time format: ${expireTime}`);
  }

  const value = parseInt(match[1]);
  const unit = match[2];

  return value * timeUnits[unit];
}
